import { useAgent, useCopilotKit } from "@copilotkit/react-core/v2";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	ActivityIndicator,
	TextInput,
	type TextInputProps,
} from "react-native-paper";
import { APPS_REDEEM_AGENT_NAME } from "../../constants";

export const Textarea = ({ label, right, ...rest }: TextInputProps) => {
	const [value, setValue] = useState("");
	const { t } = useTranslation();

	const { agent } = useAgent({ agentId: APPS_REDEEM_AGENT_NAME });
	const { copilotkit } = useCopilotKit();

	const isLoading = agent.isRunning;

	const handleMessageSend = async (text: string) => {
		if (!text) {
			return;
		}

		agent.addMessage({
			id: globalThis.crypto.randomUUID(),
			role: "user",
			content: text,
		});
		setValue("");
		await copilotkit.runAgent({ agent });
	};

	const handleTextChange = (text: string) => {
		setValue(text);
	};

	const defaultLabel = t("redeemCopilot.chat.input.label");
	const resolvedLabel = label || defaultLabel;
	const resolvedAccessibilityLabel =
		typeof label === "string" ? label : defaultLabel;

	const rightIcon = right || (
		<TextInput.Icon
			icon={(props) =>
				isLoading ? (
					<ActivityIndicator {...props} size="small" />
				) : (
					<Icon
						{...props}
						name="send"
						size={24}
						accessibilityLabel={t("redeemCopilot.chat.input.sendLabel")}
					/>
				)
			}
			forceTextInputFocus
			onPress={() => handleMessageSend(value)}
			disabled={isLoading}
		/>
	);

	return (
		<TextInput
			autoFocus
			focusable
			mode="outlined"
			blurOnSubmit={false}
			label={resolvedLabel}
			style={{ marginHorizontal: 8 }}
			right={rightIcon}
			value={value}
			accessibilityLabel={resolvedAccessibilityLabel}
			onChangeText={handleTextChange}
			onKeyPress={(e) => {
				if (e.nativeEvent.key === "Enter" && !isLoading) {
					handleMessageSend(value);
				}
			}}
			{...rest}
		/>
	);
};
